import { useSelector } from 'react-redux'
import Bird2 from '../../../../Assets/images/Bird2.svg'
import Bird3 from '../../../../Assets/images/Bird3.svg'
import Bird4 from '../../../../Assets/images/Bird4.svg'

import './WhyKhoj.css'

function WhyKhoj() {

    const { consumer } = useSelector(state => state.auth)

    return (
        <section className="why_khoj spt spb">
            <div className="container">
                <div className="sh_wrapper">
                    <h3 className='sc_heading'>
                        {
                            consumer
                                ?
                                consumer.language === 'english'
                                    ?
                                    'Why Us'
                                    :
                                    'কেন আমরা'
                                :
                                'কেন আমরা'
                        }
                    </h3>
                </div>
                <div className="why_khoj_cards">
                    <div className="card_content">
                        <img src={Bird2} alt="bird" />
                        <h3 className='card_title'>
                            {
                                consumer
                                    ?
                                    consumer.language === 'english'
                                        ?
                                        'All information in one platform'
                                        :
                                        'সব তথ্য এক প্লাটফর্মে'
                                    :
                                    'সব তথ্য এক প্লাটফর্মে'
                            }

                        </h3>
                        <p className='card_text'>
                            {
                                consumer
                                    ?
                                    consumer.language === 'english'
                                        ?
                                        'Find all the information you need from us'
                                        :
                                        'আপনার প্রয়োজনীয় সকল তথ্যের খোঁজ পাবেন আমাদের কাছে '
                                    :
                                    'আপনার প্রয়োজনীয় সকল তথ্যের খোঁজ পাবেন আমাদের কাছে '
                            }
                        </p>
                    </div>
                    <div className="card_content">
                        <img src={Bird3} alt="bird" />
                        <h3 className='card_title'>
                            {
                                consumer
                                    ?
                                    consumer.language === 'english'
                                        ?
                                        'Reliable information'
                                        :
                                        'নির্ভরযোগ্য তথ্য'
                                    :
                                    'নির্ভরযোগ্য তথ্য'
                            }
                        </h3>
                        <p className='card_text'>
                            {
                                consumer
                                    ?
                                    consumer.language === 'english'
                                        ?
                                        'We will only provide accurate information, neither fake nor false'
                                        :
                                        'ভুল কিংবা মিথ্যা নয়, শুধুমাত্র নির্ভরযোগ্য তথ্য থাকবে আমাদের কাছে'
                                    :
                                    'ভুল কিংবা মিথ্যা নয়, শুধুমাত্র নির্ভরযোগ্য তথ্য থাকবে আমাদের কাছে'
                            }
                        </p>
                    </div>
                    <div className="card_content">
                        <img src={Bird4} alt="bird" />
                        <h3 className='card_title'>
                            {
                                consumer
                                    ?
                                    consumer.language === 'english'
                                        ?
                                        'Instant Booking'
                                        :
                                        'নিমিষেই বুকিং দিন'
                                    :
                                    'নিমিষেই বুকিং দিন'
                            }
                        </h3>
                        <p className='card_text'>
                            {
                                consumer
                                    ?
                                    consumer.language === 'english'
                                        ?
                                        'You can confirm the booking from us in a quick & hassle-free manner'
                                        :
                                        'দ্রুত সময়ে, ঝামেলাহীন ভাবে বুকিং নিশ্চিত করতে পারবেন আমাদের কাছ থেকে'
                                    :
                                    'দ্রুত সময়ে, ঝামেলাহীন ভাবে বুকিং নিশ্চিত করতে পারবেন আমাদের কাছ থেকে'
                            }
                        </p>
                    </div>
                    {/* <div className="card">

                    </div>
                    <div className="card">

                    </div>
                    <div className="card">
                        
                    </div> */}
                </div>
            </div>
        </section>
    )
}

export default WhyKhoj